"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = require("react");

var _PhysicalGifts = _interopRequireDefault(require("./plum/PhysicalGifts"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2["default"])(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Group = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Group'));
  });
});
var Award = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Award'));
  });
});
var Survey = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Survey'));
  });
});
var Admin = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Admin'));
  });
});
var Report = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Report'));
  });
});
var SavingBenefit = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./SavingBenefit'));
  });
});
var Leaderboard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Leaderboard'));
  });
});
var Redeem = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Redeem'));
  });
});
var Help = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Help'));
  });
});
var AccountAdministration = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./AccountAdministration'));
  });
});
var Home = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Home'));
  });
});
var PerksBenefits = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./PerksBenefits'));
  });
});
var AccountAdministration2 = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./AccountAdministration2'));
  });
});
var Chat = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Chat'));
  });
});
var Directory = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Directory'));
  });
});
var Todo = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Todo'));
  });
});
var Celebration = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Celebration'));
  });
});
var Notification = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Notification'));
  });
});
var Search = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Search'));
  });
});
var Emoji = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Emoji'));
  });
});
var Greet = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Greet'));
  });
});
var Appreciate = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Appreciate'));
  });
});
var Doc = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Doc'));
  });
});
var Share = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Share'));
  });
});
var Attach = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Attach'));
  });
});
var Camera = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Camera'));
  });
});
var Image = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Image'));
  });
});
var Duplicate = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Duplicate'));
  });
});
var Bulb = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Bulb'));
  });
});
var At = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./At'));
  });
});
var Download = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Download'));
  });
});
var Message = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Message'));
  });
});
var Filter = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Filter'));
  });
});
var Ellipsis = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Ellipsis'));
  });
});
var EllipsisVertical = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./EllipsisVertical'));
  });
});
var HighFive = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./HighFive'));
  });
});
var PlusOne = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./PlusOne'));
  });
});
var Edit = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Edit'));
  });
});
var Funds = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Funds'));
  });
});
var Gif = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Gif'));
  });
});
var Close = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Close'));
  });
});
var Delete = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Delete'));
  });
});
var Right = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Right'));
  });
});
var Link = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Link'));
  });
});
var Calendar = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Calendar'));
  });
});
var DownArrow = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./DownArrow'));
  });
});
var UpperArrow = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./UpperArrow'));
  });
});
var LeftArrow = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./LeftArrow'));
  });
});
var RightArrow = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./RightArrow'));
  });
});
var Wallet = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Wallet'));
  });
});
var Error = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Error'));
  });
});
var Setting = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Setting'));
  });
});
var Info = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Info'));
  });
});
var Warning = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Warning'));
  });
});
var Report2 = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Report2'));
  });
});
var Refresh = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Refresh'));
  });
});
var Confirm = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Confirm'));
  });
});
var Add = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Add'));
  });
});
var Anniversary = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Anniversary'));
  });
});
var BackArrow = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./BackArrow'));
  });
});
var Valid = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Valid'));
  });
});
var Plus = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Plus'));
  });
});
var EnableUser = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./EnableUser'));
  });
});
var DisableUser = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./DisableUser'));
  });
});
var BulkUpload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./BulkUpload'));
  });
});
var RequestBudget = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./RequestBudget'));
  });
});
var ShareBudget = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./ShareBudget'));
  });
});
var BulkAppreciate = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./BulkAppreciate'));
  });
});
var Welcome = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Welcome'));
  });
});
var Disable = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Disable'));
  });
});
var Clear = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Clear'));
  });
});
var Reply = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Reply'));
  });
});
var Remove = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Remove'));
  });
});
var Upload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Upload'));
  });
});
var LoginType = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./LoginType'));
  });
});
var Lock = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Lock'));
  });
});
var Show = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Show'));
  });
});
var Hide = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Hide'));
  });
});
var HighPriority = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./HighPriority'));
  });
});
var Recommeded = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Recommeded'));
  });
});
var GroupDiscussion = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./GroupDiscussion'));
  });
});
var Event = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Event'));
  });
});
var RedeemPoint = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./RedeemPoint'));
  });
});
var MyProfile = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./MyProfile'));
  });
});
var Statement = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Statement'));
  });
});
var Settings = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Settings'));
  });
});
var AllGroup = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./AllGroup'));
  });
});
var Awards = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Awards'));
  });
});
var ShareAppreciation = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./ShareAppreciation'));
  });
});
var Leadboard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Leadboard'));
  });
});
var Budget = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Budget'));
  });
});
var GatherFeedback = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./GatherFeedback'));
  });
});
var MeasureEngagement = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./MeasureEngagement'));
  });
});
var UserManagement = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./UserManagement'));
  });
});
var ManageBudget = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./ManageBudget'));
  });
});
var Values = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Values'));
  });
});
var Automations = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Automations'));
  });
});
var Revoke = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Revoke'));
  });
});
var ManageLeaderboard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./ManageLeaderboard'));
  });
});
var BusinessInformation = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./BusinessInformation'));
  });
});
var Customization = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Customization'));
  });
});
var AccessControl = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./AccessControl'));
  });
});
var Subscription = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Subscription'));
  });
});
var Integrations = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Integrations'));
  });
});
var LiveStatus = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./LiveStatus'));
  });
});
var Recognition = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Recognition'));
  });
});
var Data = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Data'));
  });
});
var Announce = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Announce'));
  });
});
var Reward = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Reward'));
  });
});
var Gift = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Gift'));
  });
});
var Attention = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Attention'));
  });
});
var NewKid = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./NewKid'));
  });
});
var Flag = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Flag'));
  });
});
var Exit = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Exit'));
  });
});
var Note = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Note'));
  });
});
var User = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./User'));
  });
});
var Star = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Star'));
  });
});
var LinkedIn = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./LinkedIn'));
  });
});
var Hi = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Hi'));
  });
});
var Love = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Love'));
  });
});
var ThumbsUp = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./ThumbsUp'));
  });
});
var GoldCrown = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./GoldCrown'));
  });
});
var SilverCrown = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./SilverCrown'));
  });
});
var BronzeCrown = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./BronzeCrown'));
  });
});
var Poll = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Poll'));
  });
});
var Play = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Play'));
  });
});
var Global = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Global'));
  });
});
var PlumInbox = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Inbox'));
  });
});
var PlumCalendar = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Calendar'));
  });
});
var PlumList = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/List'));
  });
});
var PlumFile = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/File'));
  });
});
var PlumRocket = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Rocket'));
  });
});
var PlumCopy = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Copy'));
  });
});
var PlumLink = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Link'));
  });
});
var PlumPaymentSummary = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/PaymentSummary'));
  });
});
var PlumLogOut = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/LogOut'));
  });
});
var PlumStorefront = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Storefront'));
  });
});
var PlumWhatsapp = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Whatsapp'));
  });
});
var PlumEmail = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Email'));
  });
});
var PlumNotes = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Notes'));
  });
});
var PlumBulkUpload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/BulkUpload'));
  });
});
var PlumRecipient = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Recipient'));
  });
});
var PlumRecipients = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Recipients'));
  });
});
var PlumMessage = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Message'));
  });
});
var PlumDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Download'));
  });
});
var PlumColumns = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Columns'));
  });
});
var PlumMerchandise = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Merchandise'));
  });
});
var PlumGiftCard = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/GiftCard'));
  });
});
var PlumUpload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Upload'));
  });
});
var PlumShapes = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Shapes'));
  });
});
var PlumBack = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Back'));
  });
});
var PlumWallet = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Wallet'));
  });
});
var PlumEmpty = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Empty'));
  });
});
var PlumWarning = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Warning'));
  });
});
var PlumCheckbox = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Checkbox'));
  });
});
var PlumWebLink = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/WebLink'));
  });
});
var PlumMinus = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Minus'));
  });
});
var PlumHourGlass = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/HourGlass'));
  });
});
var PlumBulb = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Bulb'));
  });
});
var PlumChevronLeft = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/ChevronLeft'));
  });
});
var PlumChevronRight = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/ChevronRight'));
  });
});
var PlumClose = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Close'));
  });
});
var PlumColumn = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Column'));
  });
});
var PlumDelete = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Delete'));
  });
});
var PlumDisabled = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Disabled'));
  });
});
var PlumFilter = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Filter'));
  });
});
var PlumGift = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Gift'));
  });
});
var PlumGrid = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Grid'));
  });
});
var PlumHome = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Home'));
  });
});
var PlumImage = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Image'));
  });
});
var PlumInfo = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Info'));
  });
});
var PlumInfoFill = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/InfoFill'));
  });
});
var PlumIntegration = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Integration'));
  });
});
var PlumMenu = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Menu'));
  });
});
var PlumMore = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/More'));
  });
});
var PlumOpen = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Open'));
  });
});
var PlumPencil = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Pencil'));
  });
});
var PlumPlus = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Plus'));
  });
});
var PlumReport = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Report'));
  });
});
var PlumReward = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Reward'));
  });
});
var PlumSearch = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Search'));
  });
});
var PlumSetting = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Setting'));
  });
});
var PlumUser = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/User'));
  });
});
var PlumAuthenticator = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Authenticator'));
  });
});
var PlumSmartphone = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/Smartphone'));
  });
});
var PlumPhysicalGifts = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/PhysicalGifts'));
  });
});
var PlumGiftCards = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./plum/GiftCards'));
  });
});
var Icons = {
  Group: Group,
  Award: Award,
  Survey: Survey,
  Admin: Admin,
  Report: Report,
  SavingBenefit: SavingBenefit,
  Leaderboard: Leaderboard,
  Redeem: Redeem,
  Help: Help,
  AccountAdministration: AccountAdministration,
  Home: Home,
  PerksBenefits: PerksBenefits,
  AccountAdministration2: AccountAdministration2,
  Chat: Chat,
  Directory: Directory,
  Todo: Todo,
  Celebration: Celebration,
  Notification: Notification,
  Search: Search,
  Emoji: Emoji,
  Greet: Greet,
  Appreciate: Appreciate,
  Doc: Doc,
  Share: Share,
  Attach: Attach,
  Camera: Camera,
  Image: Image,
  Duplicate: Duplicate,
  Bulb: Bulb,
  At: At,
  Download: Download,
  Message: Message,
  Filter: Filter,
  Ellipsis: Ellipsis,
  EllipsisVertical: EllipsisVertical,
  HighFive: HighFive,
  PlusOne: PlusOne,
  Edit: Edit,
  Funds: Funds,
  Gif: Gif,
  Close: Close,
  Delete: Delete,
  Right: Right,
  Link: Link,
  Calendar: Calendar,
  DownArrow: DownArrow,
  UpperArrow: UpperArrow,
  LeftArrow: LeftArrow,
  RightArrow: RightArrow,
  Wallet: Wallet,
  Error: Error,
  Setting: Setting,
  Info: Info,
  Warning: Warning,
  Report2: Report2,
  Refresh: Refresh,
  Confirm: Confirm,
  Add: Add,
  Anniversary: Anniversary,
  BackArrow: BackArrow,
  Valid: Valid,
  Plus: Plus,
  EnableUser: EnableUser,
  DisableUser: DisableUser,
  BulkUpload: BulkUpload,
  RequestBudget: RequestBudget,
  ShareBudget: ShareBudget,
  BulkAppreciate: BulkAppreciate,
  Welcome: Welcome,
  Disable: Disable,
  Clear: Clear,
  Reply: Reply,
  Remove: Remove,
  Upload: Upload,
  LoginType: LoginType,
  Lock: Lock,
  Show: Show,
  Hide: Hide,
  HighPriority: HighPriority,
  Recommeded: Recommeded,
  GroupDiscussion: GroupDiscussion,
  Event: Event,
  RedeemPoint: RedeemPoint,
  MyProfile: MyProfile,
  Statement: Statement,
  Settings: Settings,
  AllGroup: AllGroup,
  Awards: Awards,
  ShareAppreciation: ShareAppreciation,
  Leadboard: Leadboard,
  Budget: Budget,
  GatherFeedback: GatherFeedback,
  MeasureEngagement: MeasureEngagement,
  UserManagement: UserManagement,
  ManageBudget: ManageBudget,
  Values: Values,
  Automations: Automations,
  Revoke: Revoke,
  ManageLeaderboard: ManageLeaderboard,
  BusinessInformation: BusinessInformation,
  Customization: Customization,
  AccessControl: AccessControl,
  Subscription: Subscription,
  Integrations: Integrations,
  LiveStatus: LiveStatus,
  Recognition: Recognition,
  Data: Data,
  Announce: Announce,
  Reward: Reward,
  Gift: Gift,
  Attention: Attention,
  NewKid: NewKid,
  Flag: Flag,
  Exit: Exit,
  Note: Note,
  User: User,
  Star: Star,
  LinkedIn: LinkedIn,
  Hi: Hi,
  Love: Love,
  ThumbsUp: ThumbsUp,
  GoldCrown: GoldCrown,
  SilverCrown: SilverCrown,
  BronzeCrown: BronzeCrown,
  Poll: Poll,
  Play: Play,
  Global: Global,
  PlumInbox: PlumInbox,
  PlumCalendar: PlumCalendar,
  PlumList: PlumList,
  PlumFile: PlumFile,
  PlumRocket: PlumRocket,
  PlumCopy: PlumCopy,
  PlumLink: PlumLink,
  PlumPaymentSummary: PlumPaymentSummary,
  PlumLogOut: PlumLogOut,
  PlumStorefront: PlumStorefront,
  PlumWhatsapp: PlumWhatsapp,
  PlumEmail: PlumEmail,
  PlumNotes: PlumNotes,
  PlumBulkUpload: PlumBulkUpload,
  PlumRecipient: PlumRecipient,
  PlumRecipients: PlumRecipients,
  PlumMessage: PlumMessage,
  PlumDownload: PlumDownload,
  PlumColumns: PlumColumns,
  PlumMerchandise: PlumMerchandise,
  PlumGiftCard: PlumGiftCard,
  PlumUpload: PlumUpload,
  PlumShapes: PlumShapes,
  PlumBack: PlumBack,
  PlumWallet: PlumWallet,
  PlumEmpty: PlumEmpty,
  PlumWarning: PlumWarning,
  PlumCheckbox: PlumCheckbox,
  PlumWebLink: PlumWebLink,
  PlumMinus: PlumMinus,
  PlumHourGlass: PlumHourGlass,
  PlumBulb: PlumBulb,
  PlumChevronLeft: PlumChevronLeft,
  PlumChevronRight: PlumChevronRight,
  PlumClose: PlumClose,
  PlumColumn: PlumColumn,
  PlumDelete: PlumDelete,
  PlumDisabled: PlumDisabled,
  PlumFilter: PlumFilter,
  PlumGift: PlumGift,
  PlumGrid: PlumGrid,
  PlumHome: PlumHome,
  PlumImage: PlumImage,
  PlumInfo: PlumInfo,
  PlumInfoFill: PlumInfoFill,
  PlumIntegration: PlumIntegration,
  PlumMenu: PlumMenu,
  PlumMore: PlumMore,
  PlumOpen: PlumOpen,
  PlumPencil: PlumPencil,
  PlumPlus: PlumPlus,
  PlumReport: PlumReport,
  PlumReward: PlumReward,
  PlumSearch: PlumSearch,
  PlumSetting: PlumSetting,
  PlumUser: PlumUser,
  PlumAuthenticator: PlumAuthenticator,
  PlumSmartphone: PlumSmartphone,
  PlumPhysicalGifts: PlumPhysicalGifts,
  PlumGiftCards: PlumGiftCards
};
exports.Icons = Icons;